import { render, staticRenderFns } from "./contract_approval.vue?vue&type=template&id=946a97b4"
import script from "./contract_approval.vue?vue&type=script&lang=js"
export * from "./contract_approval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports